import {required} from "vuelidate/lib/validators";   
import moment from 'moment' 
const StrBirimButceHarcamalari = {
    data() {
      return { 
        StrBirimButceHarcamalariData:{  
          Tarih:"",
          Donem:"",
          Aciklama:"", 
          Baslik:"",
          Birimid:null,
          Strperfdonemid:"",
          Gerceklestirmegorevlisiid:"",
          Harcamayetkilisid:"",
          Harcamatipiid:"",
          Ihaleusulleriid:"",
          Stramacid:"",
          Strperformanshedefiid:"",
          Strtabdetfaaliyetid:"",
          Deleted: false,
          Butcedisi:false
        },
          FormDataType:{    
            Baslik:{FieldName:"Baslik",Field:"input",FieldTitle:this.$t('StrBirimButceHarcamalari.AddEdit.Baslik')},
            Tarih:{FieldName:"Tarih",Field:"date",FieldTitle:this.$t('StrBirimButceHarcamalari.AddEdit.Tarih')}, 
            Birimid:{FieldName:"Birimid",Field:"combobox",FieldTitle:this.$t('StrBirimButceHarcamalari.AddEdit.Birimid'),ComboDataArray:[]}, 
            Strperfdonemid:{FieldName:"Strperfdonemid",Field:"combobox",FieldTitle:this.$t('StrBirimButceHarcamalari.AddEdit.Strdonemid'),ComboDataArray:[]}, 
            Stramacid:{FieldName:"Stramacid",Field:"combobox",FieldTitle:this.$t('StrBirimButceHarcamalari.AddEdit.Stramacid'),ComboDataArray:[]}, 
            Strperformanshedefiid:{FieldName:"Strperformanshedefiid",Field:"combobox",FieldTitle:this.$t('StrBirimButceHarcamalari.AddEdit.Strperformanshedefiid'),ComboDataArray:[]}, 
            Strtabdetfaaliyetid:{FieldName:"Strtabdetfaaliyetid",Field:"combobox",FieldTitle:this.$t('StrBirimButceHarcamalari.AddEdit.Strtabdetfaaliyetid'),ComboDataArray:[]}, 
            Donem:{FieldName:"Donem",Field:"combobox",FieldTitle:this.$t('StrBirimButceHarcamalari.AddEdit.Donem'),ComboDataArray:[]}, 
            Harcamatipiid:{FieldName:"Harcamatipiid",Field:"combobox",FieldTitle:this.$t('StrBirimButceHarcamalari.AddEdit.Harcamatipiid'),ComboDataArray:[]}, 
            Ihaleusulleriid:{FieldName:"Ihaleusulleriid",Field:"combobox",FieldTitle:this.$t('StrBirimButceHarcamalari.AddEdit.Ihaleusulleriid'),ComboDataArray:[]},
            Aciklama:{FieldName:"Aciklama",Field:"input",FieldTitle:this.$t('StrBirimButceHarcamalari.AddEdit.Aciklama')}, 
            Harcamayetkilisid:{FieldName:"Harcamayetkilisid",Field:"combobox",FieldTitle:this.$t('StrBirimButceHarcamalari.AddEdit.Harcamayetkilisid'),ComboDataArray:[]},
            Gerceklestirmegorevlisiid:{FieldName:"Gerceklestirmegorevlisiid",Field:"combobox",FieldTitle:this.$t('StrBirimButceHarcamalari.AddEdit.Gerceklestirmegorevlisiid'),ComboDataArray:[]},  
             Duzeltmenotu:{FieldName:"Duzeltmenotu",Field:"input",FieldTitle:this.$t('StrBirimButceHarcamalari.AddEdit.Duzeltmenotu')}, 
             Butcedisi: {FieldName: "Butcedisi", Field: "checkbox",FieldTitle: this.$t("StrBirimButceHarcamalari.AddEdit.Butcedisi" ),
            },

          },
          Yillar:[
            {"id":"2021","value":"2021"},
            {"id":"2022","value":"2022"},
            {"id":"2023","value":"2023"},
            {"id":"2024","value":"2024"},
            {"id":"2025","value":"2025"},
            {"id":"2026","value":"2026"},
            {"id":"2027","value":"2027"},
            {"id":"2028","value":"2028"},
            {"id":"2029","value":"2029"},
            {"id":"2030","value":"2030"},

          ],
          
        Tarih: moment(new Date()).format('YYYY-MM-DD')  
      }
    },
    validations:{ 
      FormData: { 
        Tarih: { required }, 
        Donem: { required }, 
        Aciklama: { required },  
        Baslik: { required },
        Birimid: { required },
        Strperfdonemid: { required },
        Gerceklestirmegorevlisiid: { required }, 
        Harcamatipiid: { required },
        Ihaleusulleriid: { required },
        Stramacid: { required },
        Strperformanshedefiid: { required },
        Strtabdetfaaliyetid: { required },
         Duzeltmenotu: {  },
         Butcedisi:{}
      }
 
  },
  created(){ 
    let Page= {
      PageNumber: "1",
      PageSize: "9999"
    }  
    this.ActionsGet({"Service":"OBirim","Page":Page}).then(res => {  
        for(var i=0; i<res.Data.length; i++)
        {
          this.FormDataType.Birimid.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].BirimAdi})
        }    
    }); 


    let sorgu = "&Tip=1561";
    let Tip=[];
      
      this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:sorgu}).then((res) => {
        console.log(res)
          for(var i=0; i<res.Data.length; i++)
          {   
              if(res.Data[i].Kod==1 || res.Data[i].Kod==2 ) { 

                  Tip.push(res.Data[i].Id);       

              } 
             
          }

          let altsorgu="&UstIdDoluMu=false&Approval=true";

          let tipler="";

          for (var s=0; s<Tip.length; s++){

              tipler=tipler+"&TipId="+Tip[s];

          }

          altsorgu=altsorgu+tipler;

        
          this.ActionsFilterGet({"Service":"StrPerfDonem","Page":Page,Filter:altsorgu}).then(res => {  
            for(var i=0; i<res.Data.length; i++)
              {
                if(this.$options.filters.formatDate(res.Data[i].BaslamaTarihi) <= this.Tarih && this.Tarih <= this.$options.filters.formatDate(res.Data[i].BitisTarihi)){
                  if(!res.Data[i].UstId ){
                this.FormDataType.Strperfdonemid.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Aciklama});
               // this.FormDataType.Donem.ComboDataArray.push ({Id:res.Data[i].YilBas,Value:res.Data[i].YilBas});        
              } 
            } 
              }    
          }); 
      });


      this.FormDataType.Donem.ComboDataArray=[];
      for (var i=0 ; i<this.Yillar.length; i++){
        this.FormDataType.Donem.ComboDataArray.push ({Id:this.Yillar[i].id,Value:this.Yillar[i].value})
      }



    this.ActionsSabitGet(1548).then(res => {  
      for(var i=0; i<res.Data.length; i++)
        {
          this.FormDataType.Harcamatipiid.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Value}) 
        }    
    });
    this.ActionsSabitGet(1552).then(res => {  
      for(var i=0; i<res.Data.length; i++)
        {
          this.FormDataType.Ihaleusulleriid.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Value})
        }    
    });  

    this.ActionsGet({"Service":"OPersonel","Page":Page}).then(res => {  
      for(var i=0; i<res.Data.length; i++)
        {
          this.FormDataType.Harcamayetkilisid.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Adsoyad});
          //this.FormDataType.Gerceklestirmegorevlisiid.ComboDataArray.push ({id:res.Data[i].Id,label:res.Data[i].Adsoyad})
        }    
    });  

    

    
  }
}
export default StrBirimButceHarcamalari